import { render, staticRenderFns } from "./card-recap.vue?vue&type=template&id=b81fecb4&scoped=true"
import script from "./card-recap.vue?vue&type=script&lang=js"
export * from "./card-recap.vue?vue&type=script&lang=js"
import style0 from "./card-recap.vue?vue&type=style&index=0&id=b81fecb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81fecb4",
  null
  
)

export default component.exports